import { cn } from "@/lib/utils";

/**
 * PageHeader — konsisten di semua halaman.
 * - Mobile: stack vertikal (title + description di atas, actions di bawah)
 * - Desktop: side-by-side (title kiri, actions kanan)
 */
export const PageHeader = ({ title, description, actions, children, className }) => (
    <div className={cn("mb-4 md:mb-6", className)}>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 md:gap-4">
            <div className="min-w-0 flex-1">
                <h1
                    className="text-xl md:text-2xl font-semibold tracking-tight truncate"
                    style={{ color: "var(--text-primary)", letterSpacing: "-0.3px" }}
                    data-testid="page-header-title"
                >
                    {title}
                </h1>
                {description && (
                    <p
                        className="text-xs md:text-sm mt-1"
                        style={{ color: "var(--text-secondary)" }}
                    >
                        {description}
                    </p>
                )}
                {children}
            </div>
            {actions && (
                <div className="flex items-center gap-2 flex-wrap">
                    {actions}
                </div>
            )}
        </div>
    </div>
);

export default PageHeader;
